import React, { useMemo, useEffect, useRef, useState } from "react";
import { useMap, Marker, Tooltip, Polyline } from "react-leaflet";
import L from "leaflet";
import { MapPhysics } from "./MapPhysics";

const cityIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/484/484167.png",
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

const invisibleIcon = L.divIcon({
  className: "no-marker",
  html: "",
  iconSize: [0, 0],
});

export default function MapOverlay({ groups }) {
  const map = useMap();

  const baseNodes = useMemo(() => {
    if (!map) return [];
    return MapPhysics(groups, map);
  }, [groups, map]);

  const [nodes, setNodes] = useState([]);
  const ref = useRef([]);

  // INIT
  useEffect(() => {
    if (!map) return;

    ref.current = baseNodes.map((n) => ({
      ...n,
      vx: 0,
      vy: 0,
    }));

    setNodes([...ref.current]);
  }, [baseNodes, map]);

  // 🔥 ANIMATION LOOP (LOCKED TO MAP SPACE)
  useEffect(() => {
    if (!map) return;

    let frame;

    const tick = () => {
      const arr = ref.current;

      for (let n of arr) {
        // притяжение к "якорю" (город)
        n.vx += (n.cx - n.x) * 0.02;
        n.vy += (n.cy - n.y) * 0.02;

        // мягкий шум
        n.vx += (Math.random() - 0.5) * 0.15;
        n.vy += (Math.random() - 0.5) * 0.15;

        // damping
        n.vx *= 0.88;
        n.vy *= 0.88;

        n.x += n.vx;
        n.y += n.vy;
      }

      setNodes([...arr]);
      frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [map]);

  return (
    <>
      {/* CITY */}
      {groups.map((g) => (
        <Marker
          key={g.city.id}
          position={[g.city.lat, g.city.lon]}
          icon={cityIcon}
        >
          <Tooltip permanent>
            <div style={{ color: "#00fff2", fontWeight: 600 }}>
              ⚡ {g.city.name}
            </div>
          </Tooltip>
        </Marker>
      ))}

      {/* WINDOWS + CORRECT LINES */}
      {nodes.map((n, i) => {
        if (!map) return null;

        // 🔥 node layerPoint → latlng
        const nodeLatLng = map.layerPointToLatLng([n.x, n.y]);

        // 🔥 city latlng (ВАЖНО: теперь ВСЕГДА география)
        const cityLatLng = map.layerPointToLatLng([n.cx, n.cy]);

        return (
          <React.Fragment key={i}>
            {/* ✅ ПРАВИЛЬНАЯ ЛИНИЯ: city → node */}
            <Polyline
              positions={[cityLatLng, nodeLatLng]}
              pathOptions={{
                color: "#ff2a2a",
                weight: 1.5,
                opacity: 0.8,
              }}
            />

            {/* WINDOW */}
            <Marker position={nodeLatLng} icon={invisibleIcon}>
              <Tooltip permanent>
                <div
                  style={{
                    background: "rgba(10,10,15,0.85)",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    border: "1px solid #ff2a2a",
                    boxShadow: "0 0 12px rgba(255,42,42,0.5)",
                    color: "#fff",
                    minWidth: "140px",
                    backdropFilter: "blur(6px)",
                  }}
                >
                  {n.type === "supplier" && `🏭 ${n.data.name}`}
                  {n.type === "warehouse" && `🏬 ${n.data.name}`}
                  {n.type === "order" && `📦 ${n.data}`}
                </div>
              </Tooltip>
            </Marker>
          </React.Fragment>
        );
      })}
    </>
  );
}